import React from 'react'
import './About.css'
import Section from '../section/Section'
import Technologies from '../technologies/Technologies'
import { useScrollReveal } from '../../hooks/useScrollReveal'

const About = () => {
  const revealRef = useScrollReveal({ y: 25, scale: 1.2, rotateX: 10 })

  return (
    <Section title="Sobre" stage="sobre">
      <div className="about-content">
        <div className="file-card about-text" ref={revealRef}>
          <div className="file-card-bar">
            <span className="file-card-dot" aria-hidden="true" />
            README.md
          </div>
          <div className="file-card-body">
            <p className="md-heading"># Um pouco sobre mim</p>
            <p>
              Meu nome é <strong>Jarder Silva</strong>, sou desenvolvedor
              Full-Stack com mais de <strong>10 anos de experiência</strong>{' '}
              criando aplicações web, mobile e desktop. Trabalho com todo o
              ciclo de desenvolvimento do front-end ao back-end, passando por
              integrações via API REST, micro serviços e soluções em nuvem.
            </p>
            <p>Ao longo da carreira, já contribuí em empresas como:</p>
            <ul className="md-list">
              <li>
                <strong>STW Automação</strong>
              </li>
              <li>
                <strong>Ademicon</strong>
              </li>
              <li>
                <strong>GFT Brasil</strong>
              </li>
              <li>
                <strong>Vokere</strong>
              </li>
              <li>
                <strong>FoodJá!</strong>
              </li>
              <li>
                <strong>NSC Sistemas</strong>
              </li>
            </ul>
            <p>Atuando com React, Node.js, Laravel, Flutter, Delphi e muito mais.</p>
            <p>
              Minha jornada como programador começou em 2014 e, desde então,
              busco evoluir constantemente tanto nas habilidades técnicas quanto
              no domínio do inglês para estar preparado para os desafios de um
              mercado em constante transformação.
            </p>
            <div className="md-quote location-wrapper">
              <svg
                className="octicon octicon-location"
                viewBox="0 0 16 16"
                version="1.1"
                width="16"
                height="16"
                aria-hidden="true"
              >
                <path
                  fill="var(--text-muted)"
                  fillRule="evenodd"
                  d="M11.536 3.464a5 5 0 010 7.072L8 14.07l-3.536-3.535a5 5 0 117.072-7.072v.001zm1.06 8.132a6.5 6.5 0 10-9.192 0l3.535 3.536a1.5 1.5 0 002.122 0l3.535-3.536zM8 9a2 2 0 100-4 2 2 0 000 4z"
                ></path>
              </svg>
              <p>Balsas, MA  Brasil</p>
            </div>
          </div>
        </div>
        <Technologies />
      </div>
    </Section>
  )
}

export default About
